import React, { Component } from "react"
import GoogleLogin from "react-google-login"
import { connect } from "react-redux"
import { socialLogin } from "./redux/reducers"
import styled from "styled-components"

// Amber "alternate uplink" button per the TURN 3 auth design.
const GoogleButton = styled.button`
  width: 100%;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: rgba(255, 184, 0, 0.06);
  border: 1px solid rgba(255, 184, 0, 0.7);
  color: #ffb800;
  font-family: "VT323", monospace;
  font-size: 16px;
  letter-spacing: 1px;
  cursor: pointer;

  &:hover {
    background: rgba(255, 184, 0, 0.14);
  }
`

class LoginGoogle extends Component {
  responseGoogle = response => {
    const { googleId, name, email, imageUrl } = response.profileObj
    const user = {
      password: googleId,
      name: name,
      email: email,
      imageUrl: imageUrl
    }
    this.props.socialLogin(user)
  }

  render() {
    return (
      <GoogleLogin
        clientId="665418634223-295bluqldfbutnt3jv5a7oahd4kd1cf1.apps.googleusercontent.com"
        render={renderProps => (
          <GoogleButton type="button" onClick={renderProps.onClick}>
            ◈ LOGIN WITH GOOGLE
          </GoogleButton>
        )}
        onSuccess={this.responseGoogle}
        onFailure={this.responseGoogle}
      />
    )
  }
}

export default connect(
  null,
  { socialLogin }
)(LoginGoogle)
